
export enum InvoiceAttachmentCd {
	BOL = 'BOL',
	BOTH = 'BOTH',
	DR = 'DR'}

